import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">

      {/* Logo + Brand */}
      <div className="logo-container">
        <img src="/logo.png" alt="TevixRA Logo" className="logo" />
        <h2 className="brand">TevixRA</h2>
      </div>

      {/* Center Company Name */}
      <div className="center-brand">
        <span>Software Solutions</span>
      </div>

      {/* MOBILE MENU BUTTON */}
      <div className="menu-btn" onClick={() => setOpen(!open)}>
        ☰
      </div>

      {/* Navigation Links */}
      <div className={`nav-links ${open ? "open" : ""}`}>

        <Link to="/" className="nav-link" onClick={() => setOpen(false)}>
          Home
        </Link>

        <Link to="/about" className="nav-link" onClick={() => setOpen(false)}>
          About
        </Link>

        <Link to="/career" className="nav-link" onClick={() => setOpen(false)}>
          Careers
        </Link>

        <Link to="/contact" className="nav-link" onClick={() => setOpen(false)}>
          Contact
        </Link>

       

      </div>

    </nav>
  );
}

export default Navbar;